import { RentCollectionStatus, RentCollectionStatusGroupName, RentCollectionStatusGroups } from '../entity'

export const findGroupNameByStatus = (statuses: RentCollectionStatus[]): RentCollectionStatusGroupName => {
  const [groupName] = Object.entries(RentCollectionStatusGroups).find(([_, statusGroup]) => {
    return statusGroup.length === statuses.length && statusGroup.every((g) => statuses.includes(g))
  })
  return groupName as RentCollectionStatusGroupName
}
